import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs';

import * as _ from 'lodash';

import { Auth } from '../auth.service';
import { RequestService } from '../request.service';
import { Patient } from '../../classes/patient';
import { Count } from '../../classes/count';

@Injectable()
export class UserService {

  protected getUsersUrl(): string { return; };
  protected getOneUserUrl(): string { return; };
  protected getBillUrl(): string { return; };

  protected parseObject(obj: any): any { return; };
  protected parseArray(objs: any): any[] { return; };

  constructor(protected requestService: RequestService, protected auth: Auth) { };



  get(params: any): Promise<any[]> {
    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      urlQueryParams: params
    })
      .then((response: any) => this.parseArray(response.json()));
  };

  getMe(): Promise<any> {
    //Its the first request
    this.requestService.setToken()
    return this.requestService.makeRequest({
      urlKey: 'me',
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  getCalls(params:any): Promise<any[]> {
    return this.requestService.makeRequest({
      urlKey: 'calls',
      urlQueryParams: params
    })
      .then((response: any) => this.parseArray(response.json()));
  };

  getOne(id: string): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl(),
      urlParams: {
        id: id
      }
    })
      .then((response: any) => this.parseObject(response.json()));
  };

  getInfo(auth0_user:string): Promise<any>{
    return this.requestService.makeRequest({
      urlKey: 'patientInfo',
      urlParams: {
        auth0_user: auth0_user
      }
    })
      .then((response: any) => this.parseObject(response.json()));
  }

  getFamily(id:string): Promise<any>{
    return this.requestService.makeRequest({
      urlKey: 'family',
      urlParams: {
        id:id
      }
    })
      .then((response: any) => this.parseObject(response.json()));
  }

  update(id: string, obj: any): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl(),
      urlParams: {
        id: id
      },
      method: 'put',
      body: JSON.stringify(obj)
    })
      .then(() => obj);
  };

  activate(id: string,familyGroupId:string): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl() +'Activate',
      urlParams: {
        id: id
      },
      method: 'put',
      body: JSON.stringify({familyGroup:familyGroupId})
    })
  };

  deactivate(id: string,familyGroupId:string): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl() +'Deactivate',
      urlParams: {
        id: id
      },
      method: 'put',
      body: JSON.stringify({familyGroup:familyGroupId})
    })
  };

  updateImage(userId: string, obj: any): Promise<any> {
    return this.requestService.makeRequestImage({
      urlKey: 'userFiles',
      urlParams: {
        id: userId,
      },
      method: 'put',
      body: obj
    })
      .then(() => obj);

  };

  create(params: any): Promise<any> {

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      method: 'post',
      body: JSON.stringify(params)
    })
      .then((res: any) => this.parseObject(res.json()));
  };

  delete(id: string): Promise<void> {

    return this.requestService.makeRequest({
      urlKey: this.getOneUserUrl(),
      urlParams: {
        id: id
      },
      method: 'delete'
    });
  };

  search(terms: any): Observable<any[]> {

    let urlQueryParams: any = {};

    if (_.has(terms, 'name')) {

      urlQueryParams.name = terms.name;
    }

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      urlQueryParams: urlQueryParams,
      asObservable: true
    })
      .map((res: any) => this.parseArray(res.json()));
  }

  searchBySpecialty(terms: any): Observable<any[]> {

    let urlQueryParams: any = {};

    if (_.has(terms, 'specialty')) {

      urlQueryParams.specialty = terms.specialty;
    }

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl(),
      urlQueryParams: urlQueryParams,
      asObservable: true
    })
      .map((res: any) => this.parseArray(res.json()));
  }

  getForTable(params: any): Promise<any[]> {

    console.log(this.getUsersUrl()+"Table")

    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl()+"Table",
      urlQueryParams: params
    })
      .then((response: any) => this.parseArray(response.json()));
  };

  count(params: any): Promise<any>{
    return this.requestService.makeRequest({
      urlKey: this.getUsersUrl()+"Count",
      urlQueryParams: params
    })
    .then((res: any) => {return res.json() as Count});
  }




};



// WEBPACK FOOTER //
// ./src/app/services/users/user.service.ts